<div class="flex flex-col gap-2 cursor-default">
  @if (label() && mode() !== 'button') {
    <app-label [required]="required()" [size]="size()">{{ label() }}</app-label>
  }
  <div (clickOutside)="open.set(false)" class="relative flex flex-col gap-1">
    @if (mode() === 'button') {
      <app-button
        [cdkMenuTriggerFor]="menus"
        (click)="handleOpen($event)"
        variant="outline"
        [color]="value()?.length ? 'primary' : 'gray'"
      >
        <div class="flex gap-2 items-center">
          <p class="text-sm">{{ label() }}</p>
          @if (value()?.length; as length) {
            <p class="text-sm bg-primary-50 p-1 py-0 rounded-md aspect-square">
              {{ length }}
            </p>
          }
        </div>
      </app-button>
    } @else {
      <app-input
        [cdkMenuTriggerFor]="menus"
        (click)="handleOpen($event)"
        [size]="size()"
        (keyup)="handleKeyup($event)"
        (valueChange)="handleSearch($event)"
        [(value)]="inputValue"
        [readonly]="!search() || isMobile()!"
        [placeholder]="placeholder()"
        [debounce]="search() ? 300 : 0"
        [disabled]="disabled()"
      />
    }
  </div>
  @if (showSelectedItems()) {
    <div class="flex gap-2 items-center flex-wrap">
      @for (item of value(); track $index) {
        <app-select-group-selected-item
          [bindLabel]="bindLabel()!"
          [bindValue]="bindValue()!"
          (remove)="handleRemove(item)"
          [options]="options()"
          [value]="item"
        />
      }
    </div>
  }
</div>

<ng-template #menus>
  @if (groupArray().length > 0) {
    <app-menu
      cdkMenu
      [attr.data-theme]="theme()"
      [class.invisible]="!menuRender()"
    >
      <div class="px-2 flex flex-col gap-3">
        <div class="w-full">
          <app-input
            class="w-full"
            [(value)]="query"
            [debounce]="300"
            icon="mdi:search"
            placeholder="검색"
          />
        </div>
        @for (item of currentArray(); track item) {
          <app-select-group-wrapper
            (valuesChange)="value.set($event)"
            [values]="value()"
            [bindLabel]="bindLabel()"
            [bindValue]="bindValue()"
            [item]="item"
          />
        }
      </div>
    </app-menu>
  }
</ng-template>
